import { PropsWithChildren } from 'react';
import { MAIN_CONTENT_ID } from '@repo/atomic-components';
import { ContentErrorBoundary } from '../components/ErrorBoundary';

/** Chat page content. Rendered inside `SidebarLayout`, which owns the shell and the sidebar. */
export const ChatTemplate = ({ children }: PropsWithChildren) => {
  return (
    <main id={MAIN_CONTENT_ID} tabIndex={-1} className="h-full w-full overflow-hidden focus:outline-none">
      <ContentErrorBoundary>{children}</ContentErrorBoundary>
    </main>
  );
};
